import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { ObjectManager } from '../../../concepts/objects';
import { Camera } from '../../canvas/Camera';
import { select } from '../../canvas/commands/SelectionCommands';
import { EditorSession } from '../../canvas/EditorSession';
import { Phys } from '../../canvas/entities/Phys';
import { RelativeTo } from '../../canvas/entities/Physical';
import { ContentInjector } from '../../canvas/injection/ContentInjector';
import { Selection } from '../../canvas/Selection';
import { toolReset } from '../../canvas/tooling/ToolCommands';
import { Frame } from '../frame/Frame';
import { frameCreate } from '../frame/FrameCommands';

export const objectLibraryInsert = defineCommand(
    'objectLibraryInsert',
    'Template Library: Insert...',
    async (cc, [templateId, title]: [string, string]) => {

        const api = cc.resolve(ApiClient);
        const camera = cc.resolve(Camera);
        const injector = cc.resolve(ContentInjector);
        const objects = cc.resolve(ObjectManager);
        const session = cc.resolve(EditorSession);

        const snapshot = await api.exec(v2.templates.snapshot(templateId));

        if (!title) {
            const info = await api.exec(v2.templates.findOne({ templateId }));
            title = info.label;
        }

        objects.update(() => {

            injector.injectNative(snapshot, { place: true, space: 1200, position: camera.position });

            const elmts = session.get(Selection).toArray();
            const heads = Phys.from(elmts).takeHeads();

            cc.dispatch(frameCreate, [heads.map(x => x.id), 400]);
            const [frame] = session.get(Selection).polarize(Frame);
            frame.title = title;

            cc.dispatch(toolReset);
            cc.dispatch(select, [[frame.id]]);

            const rect = frame.bounds(RelativeTo.Model);
            camera.animateToFrame(rect);

        });
    }
);
